<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter14">
<h1><a id="page_32"></a><a href="#/003toc#ch14">Julia’s Potato and Leek Soup</a></h1>
<p class="noindent">This riff on Julia Child’s traditional vichyssoise, a cold potato and leek soup, is so simple to make in the slow cooker, and the best news is, it can be made and then chilled, kept waiting for your next soirée. If you prefer to serve the soup warm, it’s terrific topped with crème fraîche and lump crabmeat.</p>
<p class="noindent">4 tablespoons (½ stick) unsalted butter</p>
<p class="noindent">4 leeks, finely chopped, using the white and a bit of the tender green parts</p>
<p class="noindent">4 large russet potatoes, peeled and cut into 1-inch chunks</p>
<p class="noindent">3 cups chicken broth</p>
<p class="noindent">Salt and freshly ground black pepper</p>
<p class="noindent">1 cup heavy cream</p>
<p class="noindent">½ cup snipped fresh chives for garnishing</p>
<p class="noindent">turn a 5- to 7-quart slow cooker on high, add the butter to the insert, and cover until the butter is melted. Add the leeks and toss with the butter. Add the potatoes and broth. Cover the slow cooker and cook the soup on high for 3 hours or on low for 5 to 6 hours, until the potatoes are tender.</p>
<p class="noindent">puree the soup with an immersion blender, or mash with a potato masher. Season with salt and pepper. Stir in the cream and turn off the slow cooker. Cool the soup, then refrigerate until chilled.</p>
<p class="noindent">serve the soup in chilled bowls and garnish with the chives.</p>
<p class="noindent">serves 8–10</p>
<h3 class="left"><span class="uppercase">VARIATION</span></h3>
<p class="noindent">instead of chives, finely chopped smoked salmon makes a lovely garnish, as does lump crabmeat or finely chopped cooked shrimp or lobster.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 020-chapter14.vue?e581c226